export const paths = {
  root: '/',
  landingPage: '/sign-in',
  login: '/sign-in',
  users: {
    root: '/users',
    create: 'create',
    assign: 'assign',
    details: 'details/:userId',
  },
  trips: {
    root: '/trips',
    details: 'details/:bookingId',
  },
  passengers: {
    root: '/passengers',
    create: 'create',
    details: 'details/:personId',
  },
  profile: {
    root: '/profile',
  },
  agreementPartners: {
    root: '/agreement-partners',
  },
  institutions: {
    root: '/institutions',
  },
  notifications: {
    root: '/notifications',
  },
  absence: {
    root: '/absence',
    list: '/absence-list',
  },
  about: {
    root: '/about',
  },
  manuals: {
    root: '/manuals',
  },
  authCallback: {
    callback: '/auth/callback',
  },
} as const;

export type AppPaths = (typeof paths)[keyof typeof paths];
